import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { NgbdSortableHeader, SortEvent } from 'src/app/_directives/sortable.directive';

import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/_services/toastservice';
import { Notifications } from 'src/app/_models/Notifications';
import { NotificationsService } from 'src/app/_services/notifications.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  providers: []
})
export class NotificationsComponent implements OnInit {
  data$: Observable<Notifications[]>;
  oldData: Notifications[];
  total$: Observable<number>;
  loading$: Observable<boolean>;
  private selectedBrand;

  locationSubscription: Subscription;
  submit: boolean;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(public service: NotificationsService,
    public ls: LocalStorageService,
    public ts: ToastService,
    public router: Router) {
    this.selectedBrand = this.ls.getSelectedUser().brandID;

    this.loading$ = service.loading$;
    this.submit = false;
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.service.getAllData();
    this.data$ = this.service.data$;
    this.total$ = this.service.total$;
    this.loading$ = this.service.loading$;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }

  Edit(notifications) {
    this.router.navigate(["admin/notifications/edit", notifications]);
  }

  /* 👇 Fixed delete — accepts any success response */
  Delete(obj) {
    if (!confirm("Are you sure to delete? ")) return;

    this.service.delete(obj).subscribe(
      (res: any) => {
        // Backend may return: 1, true, "success", { success: true }, an ID, or the deleted row.
        // Only treat explicit falsy values as failure.
        const failed = res === 0 || res === false || res === null
            || (typeof res === 'object' && res !== null && res.success === false);

        if (failed) {
          this.ts.showError("Error", "Failed to delete record.");
        } else {
          this.ts.showSuccess("Success", "Record deleted successfully.");
          this.getData();
        }
      },
      error => {
        this.ts.showError("Error", "Failed to delete record.");
      }
    );
  }

  /* 👇 Pagination helpers */
  getStartIndex(): number {
    const total = this.service.total;
    if (!total || total === 0) return 0;
    return (this.service.pageSize * (this.service.page - 1)) + 1;
  }

  getEndIndex(): number {
    const total = this.service.total;
    if (!total || total === 0) return 0;
    const end = this.service.pageSize * this.service.page;
    return end > total ? total : end;
  }
}